import React from 'react';
import { cx } from './clases';

export type TonoKpi = 'normal' | 'exito' | 'error' | 'aviso';

const TONO_VALOR: Record<TonoKpi, string> = {
  normal: 'text-metas-texto',
  exito: 'text-metas-exito',
  error: 'text-metas-error',
  aviso: 'text-metas-aviso',
};

interface Props {
  /** «Meta de tienda», «Suma capturada»… Se pinta en mayúsculas (12/600, .04em). */
  etiqueta: string;
  /** El número ya formateado (26/600, cifras tabulares). */
  valor: React.ReactNode;
  /** Complemento pequeño junto al valor («de 7»). */
  complemento?: React.ReactNode;
  /** Renglón de abajo: texto, una `BarraAvance` o una acción. */
  detalle?: React.ReactNode;
  tono?: TonoKpi;
  /** Borde izquierdo: separa las tarjetas cuando van en una misma fila del panel. */
  separada?: boolean;
  className?: string;
}

/**
 * Indicador del resumen de la tienda. Es un `role="group"` con el nombre de la
 * etiqueta, así que se encuentra y se anuncia por su nombre.
 */
export const KpiCard: React.FC<Props> = ({
  etiqueta,
  valor,
  complemento,
  detalle,
  tono = 'normal',
  separada,
  className,
}) => (
  <div
    role="group"
    aria-label={etiqueta}
    className={cx('flex min-w-0 flex-col gap-1.5 px-6 py-5', separada && 'border-l border-metas-borde-suave', className)}
  >
    <span className="text-metas-etiqueta uppercase text-metas-texto-2">{etiqueta}</span>
    <span className={cx('num text-metas-kpi', TONO_VALOR[tono])} data-testid="kpi-valor">
      {valor}
      {complemento && <span className="ml-1 text-base font-medium text-metas-texto-2">{complemento}</span>}
    </span>
    {detalle && <div className="text-xs text-metas-texto-2">{detalle}</div>}
  </div>
);

export default KpiCard;
